import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=248c54a3&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=248c54a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c54a3",
  null
  
)

export default component.exports